export default {
    ai: 'Assistente IA',
    export: 'Esportazione',
    blue: 'Blu',
    yellow: 'Giallo',
    pink: 'Rosa',
    orange: 'Arancione',
    all: 'Tutti',
    generateApaCopy: 'Creare una citazione APA',
    apaCopied: 'Citazione copiata!',
    imReading: `Sto leggendo`,
    in: 'nella',
    by: 'Da',
    article: 'Articoli',
    prevArticle: 'Articolo precedente',
    nextArticle: 'Articolo successivo',
    imHere: `Si, sono qui`,
    sessionExpiredAlert: 'La tua sessione di lettura sta per finire.',
    sessionExpiredAreYouThere: 'Sei qui?',
    sessionExpired: "La sessione di lettura è scaduta a causa dell'inattività.",
    returnToLibrary: 'Torna alla libreria',
    sessionValidExpired: 'Sessione scaduta',
    sessionValidExpiredPleaseLoginAgain: 'Effettua nuovamente il login',
    tableOfContents: 'Indice',
    tableOfContentsNotAvailable: 'Nessun indice disponibile.',
    pages: 'pagine',
    page: 'pagina',
    thumbnails: 'Miniature',
    settings: 'Impostazioni',
    bookmarks: 'Segnalibri',
    highlights: 'HighLights',
    highlight: 'HighLight',
    notes: 'Annotazioni',
    note: 'Annotazione',
    notebook: 'Notebook',
    search: 'Cerca',
    theme: 'Tema',
    pageLayout: 'Layout di pagina',
    typography: 'Tipografia',
    fontDefault: 'Predefinito',
    lineSpacing: 'Interlinea',
    lineSpacingCompact: 'Compatto',
    lineSpacingNormal: 'Normale',
    lineSpacingWide: 'Ampio',
    margins: 'Margini',
    marginsMinimum: 'Minimo',
    marginsNormal: 'Normale',
    marginsMaximum: 'Massimo',
    continuous: 'Continuo',
    onePage: 'Orizzontale',
    readingModes: 'Modalità di lettura',
    zoomTitle: 'Dimensione del testo',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Times',
    onePageScroll: 'Verticale',
    twoPages: 'Doppia',
    twoPagesScroll: 'Scorrimento di due pagine',
    citation: {
        buttons: {
            Iso690: 'Creare una citazione ISO690',
            APA: 'Creare una citazione APA',
            Vancouver: 'Creare una citazione Vancouver',
            IEEE: 'Creare una citazione IEEE',
            MLA: 'Creare una citazione MLA',
            ABNT: 'Creare una citazione ABNT',
        },
        menu: {
            title: 'Creare una citazione',
            Iso690: 'ISO 690',
            APA: 'APA',
            Vancouver: 'Vancouver',
            IEEE: 'IEEE',
            MLA: 'MLA',
            ABNT: 'ABNT',
        },
        messages: {
            copied: 'Citazione copiata!',
            availableIn: 'Disponibile in',
            online: 'Internet',
            generated: 'citata',
            websiteName: 'publica.la',
            and: 'e',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Spiegare concetto',
            expand: 'Espandere informazioni',
            summarize: "Riassumere l'idea",
        },
        menu: {
            title: 'Assistente AI (Beta)',
        },
        messages: {
            copied: '¡Risposta copiata negli appunti!',
            addedToResponse: '«Risposta copiata da publica.la Reader»',
        },
        thanksFeedback: 'Grazie per il tuo feedback!',
        errorFeedback: 'Invio del feedback fallito. Puoi riprovare?',
    },
    onlyCopy: 'Copia testo semplice',
    translate: 'Traduci',
    copy: 'copia',
    changeColor: 'Cambia colore',
    socialShare: 'Condividi',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Adatta alla pagina',
        'page-width': 'Larghezza di pagina',
    },
    filter: 'filtra',
    noFilterHighlights: 'Seleziona un filtro per vedere il testo evidenziato',
    noFilterHighlightsColor: "Non c'è nulla di evidenziato in questo colore",
    noHighlights: 'Ancora non hai evidenziato nulla',
    noFilterNotes: 'Seleziona un colore per vedere le annotazioni',
    noFilterNotesColor: 'Non ci sono annotazioni in questo colore',
    noNotes: 'Ancora non hai fatto nessuna annotazione',
    noFilterHighlightsAndNotes: 'Seleziona un colore per vedere il testo evidenziato e le annotazioni',
    noFilterHighlightsAndNotesColor: 'Non hai evidenziato ne fatto annotazioni niente in questo colore',
    noHighlightsAndNotes: 'Ancora non hai ne evidenziato ne fatto annotiazioni',
    plainCopied: 'Testo copiato!',
    onboarding: {
        next: 'Succ',
        finish: 'Fine',
        skip: 'Salta il tutorial',
        previous: 'Precedente',
        reader: {
            welcome: {
                title: 'Benvenuto nel tuo spazio di lettura',
                paragraph: 'Scopri come sfruttare al meglio i tuoi libri con gli strumenti disponibili nel lettore.',
                extraParagraph: 'Goditi il tuo nuovo spazio di lettura!',
            },
            highlights: {
                title: 'Migliora la tua esperienza di lettura',
                paragraph:
                    'Seleziona testo, evidenzia, crea note, genera citazioni, traduci e ascolta il contenuto. Porta la tua esperienza di lettura a un livello superiore in tutti i formati.',
            },
            resumes: {
                title: 'Gestisci i tuoi contenuti',
                paragraph:
                    'Aumenta la tua produttività. Gestisci note, evidenziazioni, citazioni e riassunti, secondo le tue preferenze. Condividi le tue idee in modo rapido e semplice.',
            },
            appPromote: {
                title: 'Leggi o ascolta ovunque',
                paragraph:
                    'Accedi ai tuoi contenuti quando e come vuoi, senza bisogno di una connessione a Internet, sul dispositivo che preferisci.',
                extraParagraph: 'Scarica la nostra app!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Benvenuto',
                subTitle: 'Come utilizzare il riproduttore?',
                paragraph: 'Scopri come utilizzare le funzioni e sfruttare al massimo il tuo ascolto.',
            },
            reproduction: {
                title: 'Controllo della riproduzione',
                paragraph: "Avanzare, ritardare o mettere in pausa la riproduzione dell'audiolibro.",
            },
            narratorSpeed: {
                title: 'Aumenta e riduci la velocità della narrazione',
                paragraph: "Puoi scegliere la velocità con cui ascoltare l'audiolibro, come preferisci.",
            },
            chapters: {
                title: 'Avanza e ritorna nei capitoli',
                paragraph: 'Spostati tra i capitoli in modo agile e veloce.',
            },
        },
    },
    author: 'Autore',
    publisher: 'Editore',
    narrator: 'Narratore',
    narratedBy: 'Narrato da',
    aboutThisPublication: 'Su questa pubblicazione',
    listening: {
        label: 'Ascolto',
        voice: 'Voce',
    },
    searchResultEmpty: 'Nessun risultato trovato',
    searchLengthError: 'La ricerca deve essere compresa tra 4 e 128 caratteri',
    keepTyping: 'Continua a scrivere…',
    loading: 'Caricamento...',
    searchLoading: 'Cercando...',
    searchTitle: 'Ricerca',
    lastSearch: 'Suggerimenti',
    searchExplanation: 'Trova parole in tutto il testo',
    networkIsOffline: 'Nessuna connessione internet disponibile. Alcune funzionalità non sono disponibili.',
    about: 'Riguardo',
    chapters: 'Capitoli',
    duration: 'Durata',
    narratorSpeed: 'Velocità di narrazione',
    slowNarration: 'Narrazione lenta',
    normalNarration: 'Narrazione normale',
    fastNarration: 'Narrazione veloce',
    shareIssue: 'Condidere la pubblicazione',
    shareArticle: 'Condividi articolo',
    copyUrl: 'Copia il link',
    shareCurrentPage: 'Condividi questa pagina',
    shareCurrentPosition: 'Condividi questa posizione',
    copyUrlToClipboard: 'Link copiato!',
    tooltips: {
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in',
        config: 'Impostazioni',
        tableOfContents: 'Indice',
        search: 'Cerca',
        highlights: 'In evidenza',
        notebook: 'Annotazioni',
        listen: 'Ascolta',
        bookmarks: 'Segnalibri',
        openThumbnails: 'Miniature',
        closeThumbnails: 'Esci miniature',
        download: 'Accesso offline',
        share: 'Condividi',
        prev: 'Prec',
        next: 'Succ',
        close: 'Chiude',
        back: 'Indietro',
        themeTitle: 'Aspetto',
        themeLight: 'Chiaro',
        themeDark: 'Scuro',
        themeCream: 'Crema',
        themeSepia: 'Seppia',
        themeCyan: 'Ciano',
        themeHighContrast: 'Alto contrasto',
        themeHighContrastDark: 'Alto contrasto scuro',
        clear: 'Clear',
        citation: 'Citazione',
        dictionary: 'Dizionario',
        aiIntegrations: 'Assistente AI (Beta)',
        aiAction:
            "Questo strumento utilizza l'IA, quindi potrebbero esserci informazioni imprecise. Presto ci saranno miglioramenti! Cosa ne pensi? Usa le icone qui sotto per esprimerti.",
        translate: 'Tradurre',
        about: 'Info',
        rewind: 'Riavvolgi',
        forward: 'Avanti',
        createNote: 'Crea annotazine',
        createHighlight: 'Evidenzia',
        deleteHighlight: 'Elimina evidenza',
        help: 'Aiuto',
        lists: 'Elenco',
        copy: 'Copia',
        goodResponse: 'Buona risposta',
        badResponse: 'Cattiva risposta',
        ai: 'Assistente IA',
        moreActions: 'Altre azioni',
        moreOptions: 'Altre opzioni',
        play: 'Riproduci',
        pause: 'Pausa',
        seekPosition: 'Posizione della traccia',
        zoomReset: 'Ripristina zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Tema di sistema',
        searchInBook: 'Cerca nel libro',
        pageSlider: 'Navigazione pagina',
    },
    save: 'Salva',
    delete: 'Elimina',
    cancel: 'Cancella',
    confirmDelete: {
        title: 'Elimina annotazione',
        message: 'Sei sicuro di voler eliminare questa annotazione? Questa azione non può essere annullata.',
    },
    confirmResetSettings: {
        title: 'Ripristina impostazioni',
        message: 'Tutte le impostazioni visive verranno ripristinate ai valori predefiniti.',
    },
    resetSettings: 'Ripristina impostazioni',
    writeNote: 'Scrivi annotazione',
    speakNow: 'Parla adesso',
    listeningSpeech: 'Ascoltando',
    share: {
        copyShare: 'Copia e condividi',
        qrCodeTitle: 'Codice QR',
        scanQr: 'Scansiona il codice QR usando la tua app WeChat',
        copyLink: "Copia l'URL della pubblicazione",
        copy: 'Copia',
        copied: 'copiato!',
        openWechat: 'Apri app WeChat',
        openingWechat: "Apertura dell'app WeChat...",
        sendCopiedUrl: 'Invia URL copiato a un contatto',
    },
    playing: 'Riproduzione',
    buyNow: 'Acquista ora',
    buyNowText: 'Ottieni la versione completa.',
    preview: 'Anteprima',
    changeLayoutNotAllowed: 'Il contenuto non consente di modificare il layout della pagina',
    nativeTtsLang: {
        'en-US': 'Inglese (Stati Uniti)',
        'en-GB': 'Inglese (Regno Unito)',
        'en-scozia': 'Inglese (Scozia)',
        'en-AU': 'Inglese (Australia)',
        'en-IE': 'Inglese (Irlanda)',
        'en-IN': 'Inglese (India)',
        'en-ZA': 'Inglese (Sud Africa)',
        en: 'Inglese',
        'es-AR': 'Spagnolo (Argentina)',
        'es-ES': 'Spagnolo (Spagna)',
        'es-MX': 'Spagnolo (Messico)',
        'es-US': 'Spagnolo (Stati Uniti)',
        es: 'Spagnolo',
        'it-IT': 'Italiano (Italia)',
        it: 'Italiano',
        'pt-PT': 'Portoghese (Portogallo)',
        'pt-BR': 'Portoghese (Brasile)',
        pt: 'Portoghese',
        'fr-CA': 'Francese (Canada)',
        'fr-FR': 'Francese (Francia)',
        fr: 'Francese',
        pl: 'Polacco',
        'pl-PL': 'Polacco (Polonia)',
    },
    promoteApp: {
        downloadAppStore: 'Scarica su App Store',
        downloadPlayStore: 'Disponible su Google Play',
        title_read: 'Porta la tua lettura ovunque con',
        title_audio: 'Porta il tuo audiolibro ovunque con',
        text: 'Accedi ai tuoi contenuti quando e come vuoi, senza bisogno di connessione internet, sul dispositivo che preferisci. Scarica la nostra app!',
        title_first_part: 'Con',
        title_second_part: 'porta le tue letture ovunque tu vada',
    },
    dictionary: 'Dizionario',
    selectionTooLongLine1: 'La selezione contiene molte parole.',
    selectionTooLongLine2: 'Provate a selezionare fino a 5 parole',
    dictionaryValidation: {
        message: 'Hai selezionato {count} parole.\nPer favore, prova a selezionare fino a {max} parole.',
    },
    translateValidation: {
        message: 'Hai selezionato {count} caratteri.\nPer favore, prova a selezionare fino a {max} caratteri.',
    },
    ttsValidation: {
        message: 'Hai selezionato {count} caratteri.\nPer favore, prova a selezionare fino a {max} caratteri.',
    },
    aiValidation: {
        message: 'Hai selezionato {count} caratteri.\nSeleziona tra {min} e {max} caratteri.',
    },
    alreadyPurchased: 'Già acquistato?',
    logIn: 'Effettuare il login',
    addToAList: 'Aggiungi a una lista',
    lists: 'Liste',
    nextSection: 'Sezione successiva',
    prevSection: 'Sezione precedente',
    new: 'Nuovo',
    skipLinks: {
        navLabel: 'Link di accesso rapido',
        showControls: 'Mostra controlli',
    },
    accessibility: {
        textSelected: '{count} caratteri selezionati. Strumenti di selezione disponibili.',
        pageChanged: 'Pagina {current} di {total}',
    },
};
